import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImportsModule } from "src/app/modules/shared/imports/imports.module";
import { VisorRoutingModule } from './visor-routing.module';
import { VisorComponent } from './components/visor/visor.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {CodeInputModule} from 'angular-code-input'

@NgModule({
  declarations: [VisorComponent],
  imports: [CommonModule, VisorRoutingModule, FormsModule, ReactiveFormsModule,ImportsModule,CodeInputModule],
})
export class VisorModule {}
